import React, { useMemo } from 'react'

import { Table, TableCol, TableRow } from '../../../../../components/pdf/Table'
import { TableColLabelValue, TableColText, TableHeadText } from '../../../../../components/pdf/TableHelpers'
import {
  getReplyValue,
  findReplyByQuestionName,
  totalEmployees,
  filterRepliesByQuestionName,
  remapReplyChildren,
  remapReplies,
  findReplyByReference,
  filterRepliesByParentReference,
  getImages,
  getJobDescription
} from '../../_helpers/pdfHelpers'
import Image from '../../../../../components/pdf/Image'
import Separator from '../../../../../components/pdf/Separator'
import Text, { Bold } from '../../../../../components/pdf/Text'
import View from '../../../../../components/pdf/View'
import { Grid } from '../../../../../packages/kiti/components/structure/Grid'

const RiskInventorySection = ({ serviceOrder }) => {
  const remap = useMemo(() => remapReplyChildren(serviceOrder.replies), [serviceOrder.replies])
  const total = useMemo(() => {
    return totalEmployees(serviceOrder.replies)
  }, [serviceOrder.replies])

  const localPhoto = useMemo(() => {
    const reply = findReplyByQuestionName(serviceOrder.replies, 'Foto geral atendimento:')
    return getImages(reply, 0)
  }, [serviceOrder.replies])

  const dangersByFunction = useMemo(() => {
    const { atendimento, comercial } = remapReplies(serviceOrder.replies, remap)

    const replies = atendimento.concat(comercial).map(reply => {
      const value = getReplyValue(
        findReplyByQuestionName(
          reply.childrenReplies,
          'Há riscos físicos, químicos, biológicos, acidentes ou ergonômicos na agencia? VER LISTA ABAIXO'
        )
      )
      const totalEmpolyees = getReplyValue(
        findReplyByQuestionName(reply.childrenReplies, 'Quantos funcionários possui nesse cargo?')
      )
      return {
        ...reply,
        totalEmpolyees,
        riscos: value
      }
    })

    return replies.filter(n => n)
  }, [serviceOrder.replies, remap])

  const riskMap = useMemo(() => {
    const result = {}
    const replies = filterRepliesByQuestionName(
      serviceOrder.replies,
      'Há riscos físicos, químicos, biológicos, acidentes ou ergonômicos na agencia? VER LISTA ABAIXO'
    )
    replies.forEach(reply => {
      if (reply.value) {
        const funcao = findReplyByReference(serviceOrder.replies, reply.question.parentReference).question.name
        const nomeFuncao = getJobDescription(funcao).funcao
        const outrasRespostasDoMesmoPai = filterRepliesByParentReference(
          serviceOrder.replies,
          reply.question.parentReference
        )
        const totalEmployees = getReplyValue(
          findReplyByQuestionName(outrasRespostasDoMesmoPai, 'Quantos funcionários possui nesse cargo?')
        )
        reply.value.forEach(value => {
          const { name } = value
          const cleanName = name
            .replace('ACIDENTES - ', '')
            .toLowerCase()
            .replace(/^\w/, c => c.toUpperCase())
          if (!result[cleanName]) {
            result[cleanName] = []
          }

          result[cleanName].push({ totalEmployees, funcao: nomeFuncao, nomeRisco: cleanName })
        })
      }
    })

    return result
  }, [serviceOrder.replies])

  return (
    <View id="4">
      <Text bold size="small">
        4 INVENTÁRIO DE RISCOS
      </Text>
      <Separator weight={4} />
      <View pageBreakAfter>
        <Text bold>
          Quadro I: Fase de antecipação: levantamento dos possíveis riscos presentes no ambiente, sem reconhecimento do
          risco nesta fase.
        </Text>
        <Table width="100%" style={{ pageBreakInside: 'auto' }}>
          <TableRow style={{ breakInside: 'avoid' }}>
            <TableColText colSpan={8} align="center" bold>
              IDENTIFICAÇÃO DE PERIGOS POR FUNÇÃO / GHE 1 E 2
            </TableColText>
          </TableRow>

          <TableRow style={{ breakInside: 'avoid' }}>
            <TableColText colSpan={5} bold>
              Número Trabalhadores Expostos: {total}
            </TableColText>

            <TableColText colSpan={3}>
              <Bold>Fase:</Bold> (x) Antecipação ( ) Reconhecimento
            </TableColText>
          </TableRow>

          <TableRow style={{ breakInside: 'avoid' }}>
            <TableHeadText size="xsmall" align="center">
              Setor
            </TableHeadText>

            <TableHeadText size="xsmall" align="center">
              Identificação do agente de risco
            </TableHeadText>

            <TableHeadText size="xsmall" align="center">
              Caracterização do tipo da exposição
            </TableHeadText>

            <TableHeadText size="xsmall" align="center">
              Localização/ Determinação das possíveis fontes geradoras do agente de risco
            </TableHeadText>

            <TableHeadText size="xsmall" align="center">
              Identificação da função
            </TableHeadText>

            <TableHeadText size="xsmall" align="center">
              Identificação do número de trabalhadores expostos
            </TableHeadText>

            <TableHeadText size="xsmall" align="center">
              Trajetória e possíveis danos à saúde ou impactos ao meio ambiente relacionados aos riscos identificados,
              disponíveis na literatura técnica
            </TableHeadText>

            <TableHeadText size="xsmall" align="center">
              Descrição das medidas de controle já existentes
            </TableHeadText>
          </TableRow>

          <TableRow style={{ breakInside: 'avoid' }}>
            <TableHeadText size="xsmall" align="center" colSpan={8}>
              Ruído
            </TableHeadText>
          </TableRow>

          <TableRow style={{ breakInside: 'avoid' }}>
            <TableColText size="xsmall" align="center">
              GHE 1 E 2
            </TableColText>

            <TableColText size="xsmall" align="center">
              Ruído
            </TableColText>

            <TableColText size="xsmall" align="center">
              Eventual
            </TableColText>

            <TableColText size="xsmall" align="center">
              Agência / Realização das atividades diárias de atendimento especialmente em dias de pico.
            </TableColText>

            <TableColText size="xsmall" align="center">
              Todos os cargos
            </TableColText>

            <TableColText size="xsmall" align="center">
              {total}
            </TableColText>

            <TableColText size="xsmall" align="center">
              Vias Aéreas / PAIRO – Perda Auditiva Induzida por Ruído Ocupacional
            </TableColText>

            <TableColText size="xsmall" align="center">
              Não se aplica
            </TableColText>
          </TableRow>

          <TableRow style={{ breakInside: 'avoid' }}>
            <TableHeadText size="xsmall" align="center" colSpan={8}>
              Físico, Organizacional e Cognitivo
            </TableHeadText>
          </TableRow>

          <TableRow style={{ breakInside: 'avoid' }}>
            <TableColText size="xsmall" align="center">
              GHE 1 E 2
            </TableColText>

            <TableColText size="xsmall" align="center">
              Mobiliário (quando houver ausência de suportes de monitor/note, apoio de pés, apoio de braço regulável,
              apoio lombar)
            </TableColText>

            <TableColText size="xsmall" align="center">
              Intermitente
            </TableColText>

            <TableColText size="xsmall" align="center">
              Mobiliário
            </TableColText>

            <TableColText size="xsmall" align="center">
              Todos os cargos
            </TableColText>

            <TableColText size="xsmall" align="center">
              {total}
            </TableColText>

            <TableColText size="xsmall" align="center">
              Doenças Osteomusculares (DORT)
            </TableColText>

            <TableColText size="xsmall" align="center">
              Entrega de acessórios ergonômicos/ Treinamentos online de postura e ergonomia/ Detalhamento do risco e
              acompanhamento realizado na AET/ Orientações sobre o uso dos acessórios ergonômicos./Aprofundamento do
              possível risco e acompanhamento realizado na AET.
            </TableColText>
          </TableRow>

          <TableRow style={{ breakInside: 'avoid' }}>
            <TableColText size="xsmall" align="center">
              GHE 1 E 2
            </TableColText>

            <TableColText size="xsmall" align="center">
              Postura Inadequada -Flexão e Extensão de Cotovelo
            </TableColText>

            <TableColText size="xsmall" align="center">
              Intermitente
            </TableColText>

            <TableColText size="xsmall" align="center">
              Disposição do mobiliário/ Dimensão do mobiliário
            </TableColText>

            <TableColText size="xsmall" align="center">
              Todos os cargos
            </TableColText>

            <TableColText size="xsmall" align="center">
              {total}
            </TableColText>

            <TableColText size="xsmall" align="center">
              Síndrome do Canal Cubital; Epicondilite Lateral Epicondilite Medial
            </TableColText>

            <TableColText size="xsmall" align="center">
              Entrega de acessórios ergonômicos / Treinamentos online de postura e ergonomia/ Detalhamento do risco e
              acompanhamento realizado na AET/ Manter os acessórios ergonômicos dispostos de tal forma que evite
              hiperextensão do cotovelo./Aprofundamento do possível risco e acompanhamento realizado na AET.
            </TableColText>
          </TableRow>

          <TableRow style={{ breakInside: 'avoid' }}>
            <TableColText size="xsmall" align="center">
              GHE 1 E 2
            </TableColText>

            <TableColText size="xsmall" align="center">
              Postura Inadequada -Flexão e Extensão do pescoço maior que 25º
            </TableColText>

            <TableColText size="xsmall" align="center">
              Intermitente
            </TableColText>

            <TableColText size="xsmall" align="center">
              Disposição do mobiliário/ Dimensão do mobiliário
            </TableColText>

            <TableColText size="xsmall" align="center">
              Todos os cargos
            </TableColText>

            <TableColText size="xsmall" align="center">
              {total}
            </TableColText>

            <TableColText size="xsmall" align="center">
              Cervicalgia, Mialgia do Trapézio e Cefaleia Tensional
            </TableColText>

            <TableColText size="xsmall" align="center">
              Entrega de acessórios ergonômicos (Suporte de Monitor ou Notebook; Cadeiras com regulagem de altura) /
              Treinamentos online de postura e ergonomia/ Detalhamento do risco e acompanhamento realizado na
              AET./Aprofundamento do possível risco e acompanhamento realizado na AET.
            </TableColText>
          </TableRow>

          <TableRow style={{ breakInside: 'avoid' }}>
            <TableColText size="xsmall" align="center">
              GHE 1 E 2
            </TableColText>

            <TableColText size="xsmall" align="center">
              Postura Inadequada -Inclinação do tronco de 20 a 60º
            </TableColText>

            <TableColText size="xsmall" align="center">
              Intermitente
            </TableColText>

            <TableColText size="xsmall" align="center">
              Disposição do mobiliário
            </TableColText>

            <TableColText size="xsmall" align="center">
              Todos os cargos
            </TableColText>

            <TableColText size="xsmall" align="center">
              {total}
            </TableColText>

            <TableColText size="xsmall" align="center">
              Lombalgia, Cervicalgia, Mialgia da Musculatura Paravertebral
            </TableColText>

            <TableColText size="xsmall" align="center">
              Entrega de acessórios ergonômicos (Suporte de Monitor ou Notebook; Cadeiras com regulagem de altura e com
              apoio lombar) / Treinamentos online de postura e ergonomia/ Detalhamento do risco e acompanhamento
              realizado na AET./Aprofundamento do possível risco e acompanhamento realizado na AET.
            </TableColText>
          </TableRow>

          <TableRow style={{ breakInside: 'avoid' }}>
            <TableColText size="xsmall" align="center">
              GHE 1 E 2
            </TableColText>

            <TableColText size="xsmall" align="center">
              Postura Inadequada -Rotação do tronco
            </TableColText>

            <TableColText size="xsmall" align="center">
              Eventual
            </TableColText>

            <TableColText size="xsmall" align="center">
              Disposição do mobiliário/ Dimensão do mobiliário
            </TableColText>

            <TableColText size="xsmall" align="center">
              Todos os cargos
            </TableColText>

            <TableColText size="xsmall" align="center">
              {total}
            </TableColText>

            <TableColText size="xsmall" align="center">
              Dorsalgia
            </TableColText>

            <TableColText size="xsmall" align="center">
              Entrega de acessórios ergonômicos (Cadeiras giratórias com 5 apoios e regulagem de altura) / Treinamentos
              online de postura e ergonomia/ Detalhamento do risco e acompanhamento realizado na AET./Aprofundamento do
              possível risco e acompanhamento realizado na AET.
            </TableColText>
          </TableRow>

          <TableRow>
            <TableColText size="xsmall" align="center">
              GHE 1 E 2
            </TableColText>

            <TableColText size="xsmall" align="center">
              Longos períodos sentado
            </TableColText>

            <TableColText size="xsmall" align="center">
              Eventual
            </TableColText>

            <TableColText size="xsmall" align="center">
              Característica da tarefa administrativa
            </TableColText>

            <TableColText size="xsmall" align="center">
              Todos os cargos
            </TableColText>

            <TableColText size="xsmall" align="center">
              {total}
            </TableColText>

            <TableColText size="xsmall" align="center">
              Lombalgia, Dorsalgia, Cervicalgia, Varizes de Membros Inferiores e Isquiatalgia
            </TableColText>

            <TableColText size="xsmall" align="center">
              Entrega de acessórios ergonômicos (Cadeiras giratórias com 5 apoios e regulagem de altura) / Treinamentos
              online de postura e ergonomia/ Detalhamento do risco e acompanhamento realizado na AET./Aprofundamento do
              possível risco e acompanhamento realizado na AET.
            </TableColText>
          </TableRow>

          <TableRow>
            <TableColText size="xsmall" align="center">
              GHE 1 E 2
            </TableColText>

            <TableColText size="xsmall" align="center">
              Fatores Cognitivos
            </TableColText>

            <TableColText size="xsmall" align="center">
              Intermitente
            </TableColText>

            <TableColText size="xsmall" align="center">
              Demanda de Trabalho; Controle de Jornada; Apoio de Chefia; Relacionamento Interpessoal; Aspectos
              relacionados ao cargo; Comunicação e Mudança.
            </TableColText>

            <TableColText size="xsmall" align="center">
              Todos os cargos
            </TableColText>

            <TableColText size="xsmall" align="center">
              {total}
            </TableColText>

            <TableColText size="xsmall" align="center">
              Transtorno de ansiedade generalizado, transtorno de adaptação, transtorno depressivo Burnout
            </TableColText>

            <TableColText size="xsmall" align="center">
              Domínio das atividades e rotina/ autonomia na realização das tarefas e pausas/ padronização dos aspectos
              organizacionais/ múltiplas tarefas/ pesquisa de clima/ detalhamento do risco e acompanhamento realizado na
              AET/ programas e campanhas de Saúde/ treinamentos/ canais de apoio social/ canal de
              denúncia./Aprofundamento do possível risco e acompanhamento realizado na AET.
            </TableColText>
          </TableRow>

          {riskMap['Batida contra'] && (
            <>
              <TableRow style={{ breakInside: 'avoid' }}>
                <TableHeadText size="xsmall" align="center" colSpan={8}>
                  Batida contra
                </TableHeadText>
              </TableRow>
              {riskMap['Batida contra'].map(risk => {
                return (
                  <>
                    <TableRow style={{ breakInside: 'avoid' }}>
                      <TableColText size="xsmall" align="center">
                        GHE 1 E 2
                      </TableColText>
                      <TableColText size="xsmall" align="center">
                        Batida contra
                      </TableColText>

                      <TableColText size="xsmall" align="center">
                        Eventual
                      </TableColText>

                      <TableColText size="xsmall" align="center">
                        Agência / Piso, depressões ou objetos
                      </TableColText>

                      <TableColText size="xsmall" align="center">
                        {risk.funcao}
                      </TableColText>

                      <TableColText size="xsmall" align="center">
                        {risk.totalEmployees}
                      </TableColText>

                      <TableColText size="xsmall" align="center">
                        Contato / Lesões pontuais e escoriações em casos mais graves torções e/ou fraturas ósseas
                      </TableColText>

                      <TableColText size="xsmall" align="center">
                        Sinalizações, fita antiderrapante, procedimentos de segurança para execução das atividades e
                        abertura de ordens de serviço de imediato quando constatada alguma das situações apresentadas
                        nas fontes geradoras do risco./Aprofundamento do possível risco e acompanhamento realizado na
                        AET.
                      </TableColText>
                    </TableRow>
                  </>
                )
              })}
            </>
          )}

          {riskMap['Queda de mesmo nivel'] && (
            <>
              <TableRow style={{ breakInside: 'avoid' }}>
                <TableHeadText size="xsmall" align="center" colSpan={8}>
                  Queda de mesmo nível
                </TableHeadText>
              </TableRow>
              {riskMap['Queda de mesmo nivel'].map(risk => {
                return (
                  <>
                    <TableRow style={{ breakInside: 'avoid' }}>
                      <TableColText size="xsmall" align="center">
                        GHE 1 E 2
                      </TableColText>
                      <TableColText size="xsmall" align="center">
                        Queda de mesmo nível
                      </TableColText>

                      <TableColText size="xsmall" align="center">
                        Eventual
                      </TableColText>

                      <TableColText size="xsmall" align="center">
                        Agência / Piso, depressões ou objetos
                      </TableColText>

                      <TableColText size="xsmall" align="center">
                        {risk.funcao}
                      </TableColText>

                      <TableColText size="xsmall" align="center">
                        {risk.totalEmployees}
                      </TableColText>

                      <TableColText size="xsmall" align="center">
                        Contato / Lesões pontuais e escoriações em casos mais graves torções e/ou fraturas ósseas
                      </TableColText>

                      <TableColText size="xsmall" align="center">
                        Sinalizações, fita antiderrapante, procedimentos de segurança para execução das atividades e
                        abertura de ordens de serviço de imediato quando constatada alguma das situações apresentadas
                        nas fontes geradoras do risco./Aprofundamento do possível risco e acompanhamento realizado na
                        AET.
                      </TableColText>
                    </TableRow>
                  </>
                )
              })}
            </>
          )}

          {riskMap['Queda de diferente nível'] && (
            <>
              <TableRow style={{ breakInside: 'avoid' }}>
                <TableHeadText size="xsmall" align="center" colSpan={8}>
                  Queda de diferente nível
                </TableHeadText>
              </TableRow>
              {riskMap['Queda de diferente nível'].map(risk => {
                return (
                  <>
                    <TableRow style={{ breakInside: 'avoid' }}>
                      <TableColText size="xsmall" align="center">
                        GHE 1 E 2
                      </TableColText>
                      <TableColText size="xsmall" align="center">
                        Queda de diferente nível
                      </TableColText>

                      <TableColText size="xsmall" align="center">
                        Eventual
                      </TableColText>

                      <TableColText size="xsmall" align="center">
                        Agência / Piso, depressões ou objetos
                      </TableColText>

                      <TableColText size="xsmall" align="center">
                        {risk.funcao}
                      </TableColText>

                      <TableColText size="xsmall" align="center">
                        {risk.totalEmployees}
                      </TableColText>

                      <TableColText size="xsmall" align="center">
                        Contato / Lesões pontuais e escoriações em casos mais graves torções e/ou fraturas ósseas
                      </TableColText>

                      <TableColText size="xsmall" align="center">
                        Sinalizações, fita antiderrapante, procedimentos de segurança para execução das atividades e
                        abertura de ordens de serviço de imediato quando constatada alguma das situações apresentadas
                        nas fontes geradoras do risco./Aprofundamento do possível risco e acompanhamento realizado na
                        AET.
                      </TableColText>
                    </TableRow>
                  </>
                )
              })}
            </>
          )}

          {riskMap['Queda fiação aparente'] && (
            <>
              <TableRow style={{ breakInside: 'avoid' }}>
                <TableHeadText size="xsmall" align="center" colSpan={8}>
                  Queda fiação aparente
                </TableHeadText>
              </TableRow>
              {riskMap['Queda fiação aparente'].map(risk => {
                return (
                  <>
                    <TableRow style={{ breakInside: 'avoid' }}>
                      <TableColText size="xsmall" align="center">
                        GHE 1 E 2
                      </TableColText>
                      <TableColText size="xsmall" align="center">
                        Queda fiação aparente
                      </TableColText>

                      <TableColText size="xsmall" align="center">
                        Eventual
                      </TableColText>

                      <TableColText size="xsmall" align="center">
                        Agência / Piso, depressões ou objetos
                      </TableColText>

                      <TableColText size="xsmall" align="center">
                        {risk.funcao}
                      </TableColText>

                      <TableColText size="xsmall" align="center">
                        {risk.totalEmployees}
                      </TableColText>

                      <TableColText size="xsmall" align="center">
                        Contato / Lesões pontuais e escoriações em casos mais graves torções e/ou fraturas ósseas
                      </TableColText>

                      <TableColText size="xsmall" align="center">
                        Sinalizações, fita antiderrapante, procedimentos de segurança para execução das atividades e
                        abertura de ordens de serviço de imediato quando constatada alguma das situações apresentadas
                        nas fontes geradoras do risco./Aprofundamento do possível risco e acompanhamento realizado na
                        AET.
                      </TableColText>
                    </TableRow>
                  </>
                )
              })}
            </>
          )}
        </Table>
      </View>
      <Separator weight={8} />
      <View>
        <Text bold>Quadro II: Reconhecimento dos riscos.</Text>
        <Table width="100%" style={{ pageBreakInside: 'auto' }}>
          <TableRow>
            <TableHeadText colSpan={5} align="center" bold>
              IDENTIFICAÇÃO DE PERIGOS POR FUNÇÃO / GHE 1 E 2
            </TableHeadText>
          </TableRow>
          <TableRow>
            <TableColLabelValue colSpan={3} label="SETOR" value="GHE 1 E 2" />
            <TableColLabelValue colSpan={1} label="Trabalhadores Expostos" value={total} />
            <TableColLabelValue colSpan={1} label="Fase" value={'( ) Antecipação (x) Reconhecimento'} />
          </TableRow>
          {dangersByFunction.map(risk => {
            return (
              <>
                <TableRow style={{ pageBreakInside: 'avoid', breakInside: 'avoid' }}>
                  <TableColLabelValue colSpan={5} label="Cargo" value={risk.funcao} />
                </TableRow>

                <TableRow style={{ pageBreakInside: 'avoid', breakInside: 'avoid' }}>
                  <TableColLabelValue colSpan={3} label="Descrição atividade" value={risk.descricao} width="50%" />
                  <TableCol colSpan={2} width="50%">
                    <Text bold>Foto do local:</Text>
                    <Image src={localPhoto} maxHeight={350} style={{ margin: 'auto' }} />
                  </TableCol>
                </TableRow>
              </>
            )
          })}
        </Table>
        <View style={{ pageBreakBefore: 'always' }}>
          <Separator weight={8} />
          <Text bold>Quadro III: Necessário aprofundamento – Análise Ergonômica Preliminar (AEP)</Text>
          <Table width="100%" style={{ pageBreakInside: 'auto' }}>
            <TableRow style={{ pageBreakInside: 'avoid', breakInside: 'avoid' }}>
              <TableHeadText colSpan={5} align="center" bold>
                IDENTIFICAÇÃO DE PERIGOS POR FUNÇÃO - AEP / GHE 1 E 2
              </TableHeadText>
            </TableRow>
            {dangersByFunction.map(risk => {
              return (
                <>
                  <TableRow style={{ pageBreakInside: 'avoid', breakInside: 'avoid' }}>
                    <TableColLabelValue colSpan={3} label="Descrição atividade" value={risk.descricao} width="50%" />
                    <TableCol colSpan={2} width="50%">
                      <Text bold>Foto do local:</Text>
                      <Image src={localPhoto} maxHeight={350} style={{ margin: 'auto' }} />
                    </TableCol>
                  </TableRow>
                </>
              )
            })}
          </Table>
          <Separator weight={4} />
          <Table width="100%">
            <TableRow style={{ breakInside: 'auto' }}>
              <TableColLabelValue width={'180px'} label="Número Tabalhadores Expostos" value={total} />
              <TableColLabelValue
                colSpan={2}
                label="Fase"
                value=" ( ) Antecipação ( ) Reconhecimento (X) Necessário Aprofundar, sem reconhecimento do risco no PGR"
              />
            </TableRow>
            <TableRow>
              <TableHeadText align="center">Agente/Tipo</TableHeadText>
              <TableHeadText align="center">Perigo/Fonte de Riscos</TableHeadText>
              <TableHeadText align="center">Ação</TableHeadText>
            </TableRow>
            <TableRow>
              <TableColText align="center">Ergonômico</TableColText>
              <TableColText align="center">Mobiliário</TableColText>
              <TableColText align="center">
                Necessário aprofundamento na Análise Ergonômica do Trabalho, risco inconclusivo na Análise Ergonômica
                Preliminar feita no inventário de riscos
              </TableColText>
            </TableRow>

            <TableRow>
              <TableColText align="center">Ergonômico</TableColText>
              <TableColText align="center">Postura Inadequada -Flexão e Extensão de Cotovelo</TableColText>
              <TableColText align="center">
                Necessário aprofundamento na Análise Ergonômica do Trabalho, risco inconclusivo na Análise Ergonômica
                Preliminar feita no inventário de riscos
              </TableColText>
            </TableRow>

            <TableRow>
              <TableColText align="center">Ergonômico</TableColText>
              <TableColText align="center">Postura Inadequada -Flexão e Extensão do pescoço maior que 25º</TableColText>
              <TableColText align="center">
                Necessário aprofundamento na Análise Ergonômica do Trabalho, risco inconclusivo na Análise Ergonômica
                Preliminar feita no inventário de riscos
              </TableColText>
            </TableRow>

            <TableRow>
              <TableColText align="center">Ergonômico</TableColText>
              <TableColText align="center">Postura Inadequada -Inclinação do tronco de 20 a 60º</TableColText>
              <TableColText align="center">
                Necessário aprofundamento na Análise Ergonômica do Trabalho, risco inconclusivo na Análise Ergonômica
                Preliminar feita no inventário de riscos
              </TableColText>
            </TableRow>

            <TableRow>
              <TableColText align="center">Ergonômico</TableColText>
              <TableColText align="center">Postura Inadequada -Rotação do tronco</TableColText>
              <TableColText align="center">
                Necessário aprofundamento na Análise Ergonômica do Trabalho, risco inconclusivo na Análise Ergonômica
                Preliminar feita no inventário de riscos
              </TableColText>
            </TableRow>

            <TableRow>
              <TableColText align="center">Ergonômico</TableColText>
              <TableColText align="center">Longos períodos sentado</TableColText>
              <TableColText align="center">
                Necessário aprofundamento na Análise Ergonômica do Trabalho, risco inconclusivo na Análise Ergonômica
                Preliminar feita no inventário de riscos
              </TableColText>
            </TableRow>
            <TableRow>
              <TableColText align="center">Ergonômico</TableColText>
              <TableColText align="center">Fatores Cognitivos</TableColText>
              <TableColText align="center">
                Necessário aprofundamento na Análise Ergonômica do Trabalho, risco inconclusivo na Análise Ergonômica
                Preliminar feita no inventário de riscos
              </TableColText>
            </TableRow>
          </Table>
        </View>
      </View>
    </View>
  )
}
export default RiskInventorySection
